// @flow
import loc from "i18next";
import { openDocModal } from "components/DocModal";
import { fetchRelatedDocs } from "data/api";
import { type ItemLinkTypeEnum } from "data/types";
import { toastActionResult, toastStyled, toastTypes } from "data/toast";
import { postMessageTo } from "hooks/PostMessage/Utils";
import { ArrowNavigationAction } from "hooks/PostMessage/Actions";

/**
 * opens related documents in preview
 */

type Context = {
    itemUri: string,
    itemLinkType: ItemLinkTypeEnum,
    getSource: ?boolean,
};

class doc_related {
    /* istanbul ignore next */
    logger: () => any = (...args) =>
        typeof args[0] === "boolean"
            ? toastActionResult(...args)
            : toastStyled(...args);

    onModalLoad = (e) => {
        if (!e?.isTrusted || e?.data == null) return;
        if (
            e.data == null ||
            e.data.source !== "inPoint" ||
            e.data.type !== ArrowNavigationAction.Load
        )
            return;
        // remove event listener
        window.removeEventListener("message", this.onModalLoad);
        // reload modal with related docs and setting source to document to not pagniate the doclist
        postMessageTo(
            ArrowNavigationAction.Reload,
            {
                rows: this.rows,
                currentIndex: 0,
                newSource: this.source,
            },
            window
        );
    };

    execute = async ({
        itemUri,
        itemLinkType,
        getSource,
        setTarget,
        ...relatedDocsProps
    }: Context): Promise<boolean> => {
        try {
            this.rows = await fetchRelatedDocs(
                itemUri,
                itemLinkType,
                getSource
            );
            if (!this.rows || !this.rows.length) {
                return false;
            }
            this.source = itemUri;
            // Set target for PostMessage communication
            /* istanbul ignore if */
            if (typeof setTarget === "function") {
                setTarget(window);
            }
            window.addEventListener("message", this.onModalLoad);
            openDocModal({ itemUri: this.rows[0] });
            return true;
        } catch (err) {
            this.logger({
                message: loc.t("itemActions:doc_related.error"),
                ...toastTypes.failure,
            });
        }
    };

    report = async (success: boolean): Promise<boolean> => {
        !success && this.logger(success === true, "itemActions:doc_related");
    };
}

export default doc_related;
